import { Select } from 'antd';
import React, { useImperativeHandle, useState } from 'react';

interface IStateTransfer {
  onChange: Function;
}
export default React.forwardRef((props: IStateTransfer, ref) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>('');

  const clear = () => {
    setSelectedValue(undefined);
    props.onChange('');
  };

  const _setSelectValue = (ids: string) => {
    setSelectedValue(ids);
  };

  useImperativeHandle(ref, () => ({
    clear,
    _setSelectValue,
  }));

  return (
    <>
      <div>
        <label className="text-grey-5 ml8">文件类型：</label>
        <Select
          value={selectedValue}
          style={{ width: 100 }}
          bordered={false}
          placeholder="全部"
          allowClear={true}
          onChange={(v: string) => {
            setSelectedValue(v);
            props.onChange(v);
          }}
        >
          <Select.Option value="">全部</Select.Option>
          <Select.Option value="skp">skp</Select.Option>
          <Select.Option value="rfa">rfa</Select.Option>
          <Select.Option value="gltf">gltf</Select.Option>
          <Select.Option value="glb">glb</Select.Option>
          <Select.Option value="zip">zip</Select.Option>
          <Select.Option value="max">max</Select.Option>
        </Select>
      </div>
    </>
  );
});
